import React from "react";
import "./Dashboard.scss";
import { getUser, getUsername, getToken, getGroup } from "utils/Common";
import ChatWidget from "components/ChatWidget/ChatWidget";
import ChatListing from "components/ChatListing/ChatListing";
import { Col } from "react-bootstrap";
import StompClient from "components/Dashboard/StompClient";
import { connect } from "react-redux";
import {
    initiateNewConversation,
    addNewMessage,
    setActiveConversation,
    initializeConversations,
    setClosedConversations,
    initializeTransferredConversations,
    updateMessageWithDeliveryInfo,
    updateMessageWithSeenInfo,
    updateMessageWithSuggestions,
} from "actions/conversationActions";
import PropTypes from "prop-types";

import ChatDispose from "components/ChatDispose/ChatDispose";
import { uepClient, getBaseURL, cvFleetEdgeWebsocketApiBaseURL } from "uepClient";
import { ConversationStatus } from "constants/ChatListingConstants";
import dayjs from "utils/dayjs";
import ChatExpirationService from "services/ChatExpirationService";
import { MessageSources } from "constants/MessageConstants";
import { MessageStatus } from "constants/ChatStatusConstants";
import { sortBy } from "lodash";
import { AgentViewTypes } from "constants/ChatViewConstants";
import AgentTransferSelector from "components/AgentTransferSelector/AgentTransferSelector";
import WithAlert from "hoc/WithAlert";
import { playChatAlert } from "utils/Audio";
import { MessageType, UserGroup } from "constants/UserConstants";
import CannedAndSuggestionsView from "components/CannedAndSuggestionsView/CannedAndSuggestionsView";
import { ReceiveMessageService, SendMessageService } from "services/MessageService";
import { agentBackGroundMessageCount } from "actions/agentSocketActions";

class AgentChatScreen extends React.Component {

    static propTypes = {
        initiateNewConversation: PropTypes.func.isRequired,
        addNewMessage: PropTypes.func.isRequired,
        setActiveConversation: PropTypes.func.isRequired,
        setClosedConversations: PropTypes.func.isRequired,
        updateMessageWithDeliveryInfo: PropTypes.func.isRequired,
        updateMessageWithSeenInfo: PropTypes.func.isRequired,
        updateMessageWithSuggestions: PropTypes.func.isRequired,
        activeConversationId: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        conversations: PropTypes.array,
        agentView: PropTypes.oneOf([
            AgentViewTypes.DEFAULT,
            AgentViewTypes.TRANSFER,
        ]),
        transferredConversations: PropTypes.array,
    };

    constructor(props) {
        super();
        this.currentAgentId = getUsername();
        this.onSocketConnected = this.context
    }

    componentDidMount() {
        ReceiveMessageService.listen().subscribe(this.onMessageReceived);
        this.initializeConversations();
        this.props.initializeTransferredConversations(this.currentAgentId);
        this.props.agentBackGroundMessageCount(0)
    }

    fetchClosedConversations = () => {
        uepClient()
            .get(`/agent-conversation/closed-conversations/${this.currentAgentId}`)
            .then((response) => {
                const allClosedConversations = response.data;
                const closedConversations = [];
                if (response.data !== []) {
                    allClosedConversations.forEach((closedConversation) => {
                        closedConversations.push({
                            conversationId: closedConversation.conversationId,
                            messages: [], //to be fetched from api in chat widget
                            status: ConversationStatus.CLOSED,
                            chatTransferDetails: closedConversation.chatTransferDetails || [],
                            conversationMeta: {
                                customerId: closedConversation.customerId,
                                phoneNumber: closedConversation.phoneNumber || "",
                                name: closedConversation.customerName,
                                email: closedConversation.customerEmail,
                                city: closedConversation.customerCity,
                                state: closedConversation.customerState,
                                pinCode: closedConversation.customerPincode,
                                title: closedConversation.customerTitle,
                                disposition: closedConversation.disposition,
                                subDisposition: closedConversation.subDisposition,
                                startTime: closedConversation.conversationStartTime,
                                endTime: closedConversation.conversationEndTime,
                                channel: closedConversation.channel,
                            },
                        });
                    });
                }
                this.props.setClosedConversations(closedConversations);
            })
            .catch((error) => {
                console.error(
                    "Error occurred while fetching closed conversations",
                    error.message
                );
            });
    };

    initializeConversations = () => {
        uepClient()
            .get(`/chat-message/agent/${this.currentAgentId}/active-chats`)
            .then((res) => {
                const allClientConversations = res.data;
                const initialConversations = [];
                allClientConversations.forEach((clientConversation) => {
                    const { client } = clientConversation;
                    clientConversation.conversations.forEach((conversation) => {
                        initialConversations.push({
                            conversationId: conversation.conversationId,
                            messages: conversation.messages,
                            agentId: conversation.agentId,
                            agentName: this.getAgentName(
                                conversation.agentFirstName,
                                conversation.agentLastName
                            ),
                            status: conversation.status,
                            chatTransferDetails: conversation.chatTransferDetails,
                            conversationMeta: {
                                customerId: client.customerId,
                                phoneNumber: client.phone || "",
                                clientId: client.id,
                                name: client.name,
                                email: client.email,
                                city: client.city,
                                state: client.state,
                                pinCode: client.pincode,
                                channel: conversation.channel || client.channel,
                                title: client.title,
                            },
                        });
                    });
                });
                this.props.initializeConversations(initialConversations);
                this.fetchClosedConversations();
            })
            .catch((err) => {
                console.error(
                    `Error occured while initializing conversations from active-chats`,
                    err
                );
            });
    };

    getAgentName = (firstName, lastName) => {
        switch (true) {
            case Boolean(firstName && lastName):
                return `${firstName} ${lastName}`;
            case Boolean(firstName):
                return `${firstName}`;
            case Boolean(lastName):
                return `${lastName}`;
            default:
                return "";
        }
    };


    onMessageReceived = (msg) => {
        /*
            Message Structure - {"phoneNumber": "123456789", "messageId": "msg1",
            "message": "Hello! I want to enquire about Tata Tiago.", "source": "CUSTOMER", "conversationId": "c2",
            "agentId": "ap_532865", 
            "messageTime":  "2016-08-18T06:17:10.225Z"}
        */
        const { conversations } = this.props;
        const response = JSON.parse(JSON.stringify(msg));
        const message = JSON.parse(response.body);
        const noSoundMessageTypes = [
            MessageType.DELIVERY_NOTIFICATION,
            MessageType.SEEN_NOTIFICATION,
            MessageType.SUGGESTION,
        ];
        if (!noSoundMessageTypes.includes(message.messageType)) {
            playChatAlert();
        }

        const existingConversation = conversations.find(
            (c) => c.conversationId === message.conversationId
        );
        if (existingConversation) {
            this.props.addNewMessage(message);
            if (message.messageType === MessageType.DELIVERY_NOTIFICATION) {
                this.props.updateMessageWithDeliveryInfo(message);
            }
            if (message.messageType === MessageType.SEEN_NOTIFICATION) {
                this.props.updateMessageWithSeenInfo(message);
            }
            if (message.source === MessageSources.CUSTOMER) {
                ChatExpirationService.cancelWaitingForClientReply(existingConversation);
            }
            if (message.messageStatus === MessageStatus.AUTO_CLOSURE) {
                ChatExpirationService.freezeConversation(existingConversation);
            }
            if (message.messageType === MessageType.SUGGESTION) {
                this.props.updateMessageWithSuggestions(message);
            }
        } else {
            if (message.messageStatus === MessageStatus.TRANSFERRED) {
                console.log("Received a transferred message", message);
                return this.initiateTransferredConversation(message);
            }

            const newConversation = {
                conversationId: message.conversationId,
                messages: [message],
                agentId: message.agentId,
                conversationMeta: {
                    phoneNumber: message.phoneNumber,
                    customerId: message.customerId,
                    channel: message.channel,
                },
                status: ConversationStatus.OPEN,
                chatTransferDetails: [],
            };
            this.props.initiateNewConversation(newConversation);
            if (this.isFirstConversation()) {
                this.props.setActiveConversation({
                    conversationId: newConversation.conversationId,
                    status: newConversation.status,
                });
            }
        }
    };

    initiateTransferredConversation = (message) => {
        const { conversationId, phoneNumber, customerId, channel } = message;
        const newConversation = {
            conversationId,
            messages: [message],
            agentId: this.currentAgentId,
            conversationMeta: {
                phoneNumber: phoneNumber,
                customerId: customerId,
                channel: channel,
            },
            status: ConversationStatus.OPEN,
            chatTransferDetails: [],
        };
        this.props.initiateNewConversation(newConversation, true);
        if (this.isFirstConversation()) {
            this.props.setActiveConversation({
                conversationId: newConversation.conversationId,
                status: newConversation.status,
            });
        }
    };

    isFirstConversation = () => {
        const { conversations } = this.props;
        return (
            conversations.filter(
                (c) =>
                    c.status === ConversationStatus.OPEN ||
                    c.status === ConversationStatus.AUTO_CLOSURE
            ).length === 0
        );
    };

    onSendNewMessage = (message) => {
        /*
          Message structure to be of:
          {
            conversationId:"c123",
            "phoneNumber:9034234234"
            "agentId":"ap_532865",
            "message":"Hello, from agent"
          }
         */
        // Adding a new message as agent
        SendMessageService.receive(message)
        console.info(`Message sent :`, message);
    };

    getDisplayName = () => {
        let displayName;
        const userFullName = getUser();
        if (!userFullName || userFullName === "") {
            displayName = getUsername();
        } else {
            displayName = userFullName;
        }
        return displayName;
    };

    getActiveConversation = () => {
        const { conversations, activeConversationId } = this.props;
        const activeConversation = conversations.find(
            (c) => c.conversationId === activeConversationId
        );
        return activeConversation;
    };

    getListOfOpenConversations = () => {
        const { conversations } = this.props;
        return conversations.filter((c) => c.status === ConversationStatus.OPEN);
    };

    getOlderConversations = (customerId) => {
        const { conversations } = this.props;
        const conversationsOfSameClient = conversations.filter(
            (c) =>
                c.conversationMeta.customerId === customerId &&
                c.status === ConversationStatus.CLOSED &&
                c.messages.length //Closed conversations fetched has no messages populated initially
        );

        const olderConversations = conversationsOfSameClient.map((c) => {
            const lastMessageOfConversation = c.messages.length
                ? c.messages[c.messages.length - 1]
                : null;
            const timeOfLastMsgInConversation = lastMessageOfConversation.messageTime;
            return {
                ...c,
                conversationDate: dayjs(timeOfLastMsgInConversation),
            };
        });

        return sortBy(olderConversations, (c) => {
            return dayjs(c.conversationDate);
        });
    };

    renderChatWidgetsForConversations = () => {
        const { activeConversationId, activeConversationStatus } = this.props;
        const openConversations = this.getListOfOpenConversations();
        const selectedConversation = this.getSelectedConversation();

        const renderWidgetForClosedOrTransferred =
            selectedConversation &&
            (selectedConversation.status === ConversationStatus.CLOSED ||
                selectedConversation.status === ConversationStatus.AUTO_CLOSURE ||
                selectedConversation.status === ConversationStatus.TRANSFERRED);

        return (
            <>
                {openConversations.map((conversation) => (
                    <ChatWidget
                        key={conversation.conversationId + conversation.status}
                        conversation={conversation}
                        olderConversations={this.getOlderConversations(
                            conversation.conversationMeta.customerId
                        )}
                        onSendNewMessage={this.onSendNewMessage}
                        isActive={
                            conversation.conversationId === activeConversationId &&
                            conversation.status === activeConversationStatus
                        }
                    />
                ))}
                {renderWidgetForClosedOrTransferred && (
                    <ChatWidget
                        className="closed-conv-widget"
                        key={
                            selectedConversation.conversationId + selectedConversation.status
                        }
                        conversation={selectedConversation}
                        isActive={
                            selectedConversation.conversationId === activeConversationId &&
                            selectedConversation.status === activeConversationStatus
                        }
                    />
                )}
            </>
        );
    };

    isConversationOpen = () => {
        const selectedConversation = this.getSelectedConversation();
        return (
            selectedConversation &&
            selectedConversation.status === ConversationStatus.OPEN
        );
    };
    getSelectedConversation = () => {
        const {
            activeConversationId,
            conversations,
            activeConversationStatus,
        } = this.props;

        const selectedConversation = conversations.find(
            (c) =>
                c.conversationId === activeConversationId &&
                c.status === activeConversationStatus
        );
        if (selectedConversation) {
            return selectedConversation;
        }

        const transferredConversations = this.getTransferredConversations();
        const selectedTransferredConversation = transferredConversations.find(
            (c) =>
                c.conversationId === activeConversationId &&
                c.status === activeConversationStatus
        );
        if (selectedTransferredConversation) {
            return selectedTransferredConversation;
        }
    };

    getTransferredConversations = () => {
        return this.props.transferredConversations;
    };

    renderDisposeAndTransferComponents = () => {
        return (
            <div className={`dispose-and-transfer-container`}>
                <ChatDispose />
            </div>
        );
    };

    render() {
        const { conversations, agentView } = this.props;
        return (

            <div className="dashboard-content">
                <Col className="dashboard-col chat-listing" md="3">
                    <ChatListing
                        conversations={conversations}
                        agentId={this.currentAgentId}
                    />
                </Col>
                <Col className={`dashboard-col chat-widget-container`} md="5">
                    {this.renderChatWidgetsForConversations()}
                    {this.renderDisposeAndTransferComponents()}
                </Col>
                <Col className="dashboard-col canned-msgs-container" md="4">
                    {agentView === AgentViewTypes.TRANSFER &&
                        this.isConversationOpen() ? (
                        <AgentTransferSelector />
                    ) : (
                        <CannedAndSuggestionsView />
                    )}
                </Col>
            </div>

        );
    }
}
const mapStateToProps = (state) => ({
    activeConversationId: state.conversation.activeConversationId,
    activeConversationStatus: state.conversation.activeConversationStatus,
    conversations: state.conversation.conversations,
    agentView: state.agentView,
    transferredConversations: state.conversation.transferredConversations,
});

const mapDispatchToProps = {
    initiateNewConversation,
    addNewMessage,
    setActiveConversation,
    initializeConversations,
    setClosedConversations,
    initializeTransferredConversations,
    updateMessageWithDeliveryInfo,
    updateMessageWithSeenInfo,
    updateMessageWithSuggestions,
    agentBackGroundMessageCount,
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WithAlert(AgentChatScreen));
